module.exports = __webpack_public_path__ + "static/media/icon-help.5ff3e846.svg";